import { navigate } from "gatsby"
import React, { memo, useEffect, useState } from "react"
import FormButtonRed from "../buttons/formButtonRed/formButtonRed"
import { useForm } from "react-hook-form"
import axios from "axios"
import { useLocation } from "@reach/router"
import { browserName, browserVersion } from "react-device-detect"
import * as style from "./postCommentForm.module.css"

const PostCommentForm = ({ CustomClass }) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm()

  const [ip, setIP] = useState("")
  const [browser, setBrowser] = useState("")

  const getGeoInfo = () => {
    axios
      .get("https://ipapi.co/json/")
      .then(({data}) => {
        // let data = response.data
        setIP(data?.ip)
        setBrowser(`${browserName} ${browserVersion}`)
      })
      .catch(error => {
        console.error(error);
      })
  }

  useEffect(() => {
    getGeoInfo()
  }, [])

  const location = useLocation()
  const path = location?.pathname?.split("/")[2]
  const url = location?.href
  // const modelRef = useRef();
  // const [eBookModal, seteBookModal] = useState(false)

  const onSubmit = value => {
    navigate("/thank-you")
    // seteBookModal(true)
    let formData = new FormData()
    formData.append("email", value?.email)
    formData.append("full_name", value?.fullname)
    formData.append("comment", value?.comment)
    formData.append("blog_slug", path)
    formData.append("author_url", url)
    formData.append("author_IP", ip)
    formData.append("agent", browser)

    axios({
      method: "post",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/newcomment/`,
      data: formData,
      // headers: { "Content-Type": "multipart/form-data" },
    })
    reset({
      email: "",
      comment: "",
      fullname: "",
    })
  }

  const emailRequired = errors.email && errors.email.type === "required"
  const emailPattern = errors.email && errors.email.type === "pattern"

  return (
      <section className={`${style.post_comment_form} ${CustomClass}`}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <h3>Comments </h3>
          <div className={style.post_comment_form_wrap}>
            <div className={style.post_comment_form_left}>
              <ul className={style.post_comment_form_listing}>
                <li>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <input
                        type="text"
                        className={style.input_grp}
                        placeholder="Full Name"
                        {...register("fullname", {
                          required: true,
                          validate: fullname => {
                            if (!fullname?.trim()) {
                              return "invalid"
                            }
                          },
                        })}
                      />
                      {errors.fullname && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Full Name is Required!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className={style.two_col}>
                    <div className={style.form_grp}>
                      <input
                        type="text"
                        className={style.input_grp}
                        placeholder="Email"
                        {...register("email", {
                          required: true,
                          pattern:
                            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
                        })}
                      />
                      {emailRequired && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Email is Required!!{" "}
                        </span>
                      )}
                      {emailPattern && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Please Enter Valid Email{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </li>
                <li>
                  <div className={style.full_col}>
                    <div className={style.form_grp}>
                      <textarea
                        className={style.input_grp}
                        placeholder="Comment here"
                        {...register("comment", {
                          required: true,
                          validate: comment => {
                            if (!comment?.trim()) {
                              return "invalid"
                            }
                          },
                        })}
                      />
                      {errors.comment && (
                        <span
                          style={{
                            color: "#e95444",
                            marginTop: "5px",
                            display: "inline-block",
                          }}
                        >
                          Please Enter Comments!!{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </li>
                <li>
                  <div className={style.submit_area}>
                    <div className={style.form_grp}>
                      <p></p>
                      <FormButtonRed customClass={`medium ${style.submit_btn}`} btnText="Comment" />
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </form>
      </section>
  )
}

export default memo(PostCommentForm)
